import * as util from "../../globals/methods/util";
import _ from "lodash";

const BANK_STATEMENT_TYPES = ["STC", "STP"];
const SUCCESSFUL_BANK_LOGIN = 3;
const VALID_BANK_PROVIDERS = ["decisionLogic", "plaid"];
const MANUAL_VERIFICATION_PROVIDER = "manualVerification";
const BANK_TRANSACTION_DOCUMENT_TYPE = "bankTransactions";
const getObjKey = util.getObjKey;
const objectToArray = util.objectToArray;

export const getLoanField = (state, field, defaultValue) =>
  _.get(state, `loan.loanJson.${field}`, defaultValue);

export const getLoan = state => _.get(state, "loan.loanJson");

export const getIncomeSummaryProviders = state => {
  const providers = getObjKey(
    state,
    "loan.loanJson.incomeSummary.providers",
    {}
  );
  return objectToArray(providers);
};

export const getUpdatingIncomeSource = state => state.loan.updatingIncomeSource;

export const isBankSourceMapped = (state, documentId) => {
  const verifiedBankSources = getVerifiedBankSources(state);
  const foundItems = Object.keys(verifiedBankSources).filter(key => {
    const verifiedItem = verifiedBankSources[key];
    return verifiedItem.bankDocumentId === documentId;
  });
  return foundItems.length > 0;
};

export const isMappedTransaction = (state, transaction) => {
  const verifiedBankSources = getVerifiedBankSources(state);
  const foundItems = Object.keys(verifiedBankSources).filter(key => {
    const verifiedItem = verifiedBankSources[key];
    return (
      parseFloat(verifiedItem.amount) === parseFloat(transaction.Amount) &&
      verifiedItem.date === transaction.TransactionDate &&
      verifiedItem.description === transaction.Description
    );
  });
  return foundItems.length > 0;
};

export const getSelectedIncomeSource = state => state.loan.selectedIncomeSource;

export const getLoanError = state => state.loan.error;

export const getVerifiedBankSources = state =>
  getObjKey(state, "loan.selectedIncomeSource.verifiedBankSources", {});

export const getLoanDocuments = state => {
  const documents = getObjKey(state, "loan.loanJson.documents", {});
  return objectToArray(documents);
};

export const getBankStatementDocuments = state => {
  const documents = getLoanDocuments(state);
  return documents.filter(
    document => BANK_STATEMENT_TYPES.indexOf(document.documentType) > -1
      && document.reviewStatus !== "rejected"
  );
};

export const getBankReportDocuments = state => {
  const documents = getLoanDocuments(state);
  return documents.filter(
    document => document.documentType === BANK_TRANSACTION_DOCUMENT_TYPE
  );
};

export const getBankLoginProviders = state => {
  const providers = getIncomeSummaryProviders(state);
  return providers.filter(provider => isValidBankLoginProvider(provider));
};

export const getBankLoginDetails = state => {
  const validProviders = getBankLoginProviders(state);
  const bankLoginDetails = [];
  validProviders.map(incomeProvider =>
    incomeProvider.details
      .filter(incomeDetails => isValidBankLoginDetails(incomeDetails))
      .map(incomeDetails => bankLoginDetails.push(incomeDetails))
  );
  return bankLoginDetails;
};

export const hasSelectedManualIncomeSource = state => {
  const { documentId = "", provider = "" } =
    getSelectedIncomeSource(state) || {};
  return Boolean(documentId) && provider === MANUAL_VERIFICATION_PROVIDER;
};

export const getLoanOfferHistory = state =>
  state.loan.loanJson.loanOfferHistory || [];

export const getPriorityHistory = state =>
  state.loan.loanJson.priorityHistory || [];

export const getLoanId = ({ loan }) => _.get(loan, "loanJson.loanId");

export const getStatusCode = ({ loan }) => loan.loanJson.statusCode;

export const getSelectedOffer = state => {
  const selectedOffer = state && state.loan && state.loan.loanJson && state.loan.loanJson.selectedOffer;
  return selectedOffer;
};

export const getVerifiedAnnualAmount = ({ loan }) =>
  _.get(loan, "loanJson.incomeSummary.verified.annualAmount") || 0;

export const isIncomeVerified = ({ loan }) =>
  _.get(loan, "loanJson.incomeSummary.isVerified");

export const getIncomeSummaryAutoVerification = ({ loan }) =>
  _.get(loan, "loanJson.incomeSummary.verified.autoVerification");

export const verifiedBelowMinimum = ({ loan }) => {
  const verifiedAmount = _.get(loan, "loanJson.incomeSummary.verified.annualAmount") || 0;
  return verifiedAmount < window.globalConfig.minimumVerifiedIncome;
}

// ///////////////
// ///PRIVATE/////
// ///////////////

const isValidBankLoginProvider = provider =>
  VALID_BANK_PROVIDERS.indexOf(provider.provider) > -1 &&
  Array.isArray(provider.details);

const isValidBankLoginDetails = details =>
  details.statusCode === SUCCESSFUL_BANK_LOGIN;
